import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SelectionEvent } from 'app/modules/action-plan/components/action-plan-table/action-plan-table.component';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-add-action-plan-dialog',
  templateUrl: './add-action-plan-dialog.component.html',
  styleUrls: ['./add-action-plan-dialog.component.scss'],
  standalone: false,
})
export class AddActionPlanDialogComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  @Input() selectedIds: string[];

  @Output() close = new EventEmitter<string[] | null>();

  private ids: string[] = [];

  onSelect(event: SelectionEvent): void {
    if (event.isChecked) {
      this.ids.push(event.id);
    } else {
      this.ids.splice(this.ids.indexOf(event.id), 1);
    }
  }

  onAdd(): void {
    this.close.emit(this.ids);
  }

  onCancel(): void {
    this.close.emit(null);
  }

  get isAddDisabled(): boolean {
    return !this.ids.length;
  }
}
